<template>
    <v-card class="p-4 w-100 mr-4 delegation">
        <v-toolbar class="shadow-none" style="flex: unset;" content-class="h-auto">
                <div class="custom-icon-wrapper">
                    <v-icon @click="backToDashboardsPage()">custom-icon left-arrow-icon</v-icon>
                </div>
                <v-toolbar-title class="size-16 dark-text p-4 label">{{ $t("res_label_average_transfer_completion") }}</v-toolbar-title>
        </v-toolbar>
        <hr>
        <div class="container">
            <v-row>
                <v-col cols="6">
                    <v-label class="label_required mb-1">{{ $t("res_label_year") }}<span> *</span></v-label>
                    <multi-select class="light-bg add-arrow" v-model="tempFilter.fromYear" label="name"
                        :placeholder="$t('res_Label_Select')" track-by="id" open-direction="bottom" :options="year_items"
                        :searchable="false" :internal-search="false" :clear-on-select="false" :close-on-select="true"
                        :max-height="600" :show-no-results="false" :hide-selected="false"
                        :multiple="false">
                    </multi-select>
                </v-col>
                <v-col cols="6">
                    <v-label class="label_required mb-1">{{ $t("res_Label_SelectCategory") }}<span> *</span></v-label>
                    <multi-select class="light-bg add-arrow" v-model="tempFilter.categoriesList" label="name"
                        placeholder="Select Category" track-by="id" open-direction="bottom" :options="category_items"
                        :searchable="false" :internal-search="false" :clear-on-select="false" :close-on-select="false"
                        :options-limit="6" :max-height="600" :show-no-results="false" :hide-selected="false"
                        :multiple="true">
                    </multi-select>
                </v-col>
            </v-row>
            <v-row>
                <div class="d-flex justify-space-between align-items-center">
                    <v-checkbox v-model="tempFilter.getAllHierarchy" :label="getAllHierarchyLabel" class="mt-0"></v-checkbox>
                    <div class="d-flex gap-2">
                        <v-btn @click="clearFilter()" color="light-blue">{{ $t("res_ButtonText_Clear") }}</v-btn>
                        <v-btn dense class="primary" @click="updateFilter()">
                            {{ $t("res_ButtonText_Search") }}
                        </v-btn>
                    </div>
                </div>
            </v-row>
        </div>
        <hr>
        <div v-if="completionValues.length > 0">
            <div class="row align-items-start m-0 gap-2">
                <v-card class="bg-white rounded-top-corners rounded-4">
                    <v-card-text class="dashboarCardTitle mt-2">
                        <p>{{ averageCompletiondataSeries[0].headerLabel }}</p>
                        <p>({{ $t("res_label_year") }}: <span style="color: #1B9C85">{{ filter.fromYear }}</span>)</p>
                    </v-card-text>
                    <apexchart type="line" height="300" :options="chartOptions" :series="averageCompletiondataSeries">
                    </apexchart>
                </v-card>
            </div>
        </div>
        <div v-if="items.length > 0">
            <div class="row align-items-start m-0 pt-5 gap-2">
                <v-card class="bg-white rounded-top-corners rounded-4">
                    <v-card-text class="dashboarCardTitle mt-2">
                        <p>{{ $t("res_label_average_per_structure") }}</p>
                        <p>({{ $t("res_label_year") }}: <span style="color: #1B9C85">{{ filter.fromYear }}</span>)</p>
                    </v-card-text>
                    <v-data-table :headers="structuresHeaders" :items="items" :items-per-page="10">
                        <template v-slot:[`item.name`]="{ item }">
                            <span style="color: #1B9C85; text-decoration: underline; cursor: pointer;"
                                @click="handleStructureClick(item)">
                                {{ item.name }}
                            </span>
                        </template>
                        <template v-slot:[`item.averageComparison`]="{ item }">
                            <span :style="{ color: item.averageComparison >= averageCompletion ? '#1B9C85' : 'red' }">
                                {{ item.averageComparison <= averageCompletion ? '+' : '-' }}{{ item.averageComparison }}
                                    </span>
                        </template>
                        <template v-slot:[`item.yearlyGraph`]="{ item }">
                            <v-icon @click="handleStructureGraph(item)">mdi-chart-line</v-icon>
                        </template>
                    </v-data-table>
                </v-card>
            </div>
        </div>
        <div v-if="showStructureGraph">
            <div class="row align-items-start m-0 pt-5 gap-2">
                <v-card class="bg-white rounded-top-corners rounded-4">
                    <v-card-text class="dashboarCardTitle mt-2">
                        <p>({{ $t("res_label_year") }}: <span style="color: #1B9C85">{{ filter.fromYear }}</span>)</p>
                    </v-card-text>
                    <apexchart type="line" height="300" :options="structureChartOptions"
                        :series="averageCompletionStructuredataSeries">
                    </apexchart>
                </v-card>
            </div>
        </div>
        <div v-if="showListUsers">
            <div class="row align-items-start m-0 pt-5 gap-2">
                <v-card class="bg-white rounded-top-corners rounded-4">
                    <v-card-text class="dashboarCardTitle mt-2">
                        <p>{{ $t("res_label_average_per_user") }}</p>
                        <p>(<span style="color: #1B9C85">{{ activeStructureName }}</span>)</p>
                    </v-card-text>
                    <v-data-table :headers="usersHeaders" :items="listUsers" :items-per-page="10">
                        <template v-slot:[`item.structureAverageComparison`]="{ item }">
                            <span
                                :style="{ color: item.averageComparison >= item.structureAverageComparison ? '#1B9C85' : 'red' }">
                                {{ item.averageComparison <= item.structureAverageComparison ? '+' : '-' }}{{
                                    item.structureAverageComparison }} </span>
                        </template>
                        <template v-slot:[`item.averageComparison`]="{ item }">
                            <span :style="{ color: item.averageComparison >= item.structureAverage ? '#1B9C85' : 'red' }">
                                {{ item.averageComparison <= averageCompletion ? '+' : '-' }}{{ item.averageComparison }}
                                    </span>
                        </template>
                    </v-data-table>
                </v-card>
            </div>
        </div>
    </v-card>
</template>
<style scoped></style>
<script>
import constants from "@/assets/js/constants.js";
import axios from "axios";
import MultiSelect from 'vue-multiselect';
import router from '../../router/index.js';
import * as utils from '@/assets/js/common.js';

export default {
    name: "AverageCompletionDashboard",
    components: { MultiSelect },
    data() {
        const englishMonths = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        const arabicMonths = [
            'يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
            'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'
        ];
        return {
            getAllHierarchyLabel: "",
            utils: utils,
            activeStructureName: "",
            showStructureGraph: false,
            showListUsers: false,
            averageCompletion: 0,
            forListDto: {
                from: [],
                year: "",
                categories: [],
                getAllHierarchy: false
            },
            structuresHeaders: localStorage.getItem('lang') == 'ar' ?
                [
                    { text: 'الإدراة', value: 'name', 'sortable': false },
                    { text: 'المتوسط (أيام)', value: 'average', 'sortable': false },
                    { text: 'مقارنة مع المتوسط الكلي', value: 'averageComparison', 'sortable': false },
                    { text: 'الرسم البياني السنوي', value: 'yearlyGraph', 'sortable': false }
                ] : [
                    { text: 'To Structure', value: 'name', 'sortable': false },
                    { text: 'Average (Days)', value: 'average', 'sortable': false },
                    { text: 'Compare to Total Average', value: 'averageComparison', 'sortable': false },
                    { text: 'Yearly Graph', value: 'yearlyGraph', 'sortable': false }
                ],
            usersHeaders: localStorage.getItem('lang') == 'ar' ?
                [
                    { text: 'المستخدم', value: 'username', 'sortable': false },
                    { text: 'المتوسط (أيام)', value: 'average', 'sortable': false },
                    { text: 'مقارنة مع المتوسط الكلي للادارة', value: 'structureAverageComparison', 'sortable': false },
                    { text: 'مقارنة مع المتوسط الكلي', value: 'averageComparison', 'sortable': false },
                ] : [
                    { text: 'To User', value: 'username', 'sortable': false },
                    { text: 'Average (Days)', value: 'average', 'sortable': false },
                    { text: 'Compare to Structure Total Average', value: 'structureAverageComparison', 'sortable': false },
                    { text: 'Compare to Total Average', value: 'averageComparison', 'sortable': false },
                ],
            items: [],
            listStructuresIds: [],
            listUsers: [],
            listUsersIds: [],
            category_items: localStorage.getItem('lang') == 'ar' ?
                [
                    { name: "وارد", id: 1 },
                    { name: "صادر", id: 2 },
                    { name: "داخلي", id: 3 },
                    { name: "تعميم", id: 4 },
                    { name: "قرار", id: 5 },
                    { name: "محضر اجتماع", id: 6 }
                ] : [
                    { name: "Incoming", id: 1 },
                    { name: "Outgoing", id: 2 },
                    { name: "Internal", id: 3 },
                    { name: "Circular", id: 4 },
                    { name: "Decree", id: 5 },
                    { name: "MOM", id: 6 }
                ],
            year_items: [
                    { name: "2018", id: 2018 },
                    { name: "2019", id: 2019 },
                    { name: "2020", id: 2020 },
                    { name: "2021", id: 2021 },
                    { name: "2022", id: 2022 },
                    { name: "2023", id: 2023 },
                    { name: "2024", id: 2024 },
                    { name: "2025", id: 2025 },
                    { name: "2026", id: 2026 },
                    { name: "2027", id: 2027 },
                    { name: "2028", id: 2028 }
                ],
            filterDialog: false,
            tempFilter: {
                categoriesList: [{ id: 0, name: '' }],
                fromYear: { id: new Date().getFullYear(), name: new Date().getFullYear() },
                error: false,
                getAllHierarchy: false
            },
            filter: {
                categoriesList: [],
                fromYear: { id: new Date().getFullYear(), name: new Date().getFullYear() },
                getAllHierarchy: false
            },
            completionValues: [],
            structureCompletionValues: [],
            averageCompletiondataSeries: [{
                name: "Average completion in month",
                data: [],
                headerLabel: localStorage.getItem('lang') == 'ar' ? "المتوسط في السنة" : "Average per year"
            }],
            chartOptions: {
                title: {
                    text: "",
                    floating: 0,
                    offsetY: 20,
                    align: "center",
                    style: {
                        color: "#444"
                    }
                },
                markers: {
                    seriesIndex: 0,
                    colors: '#0E21A0',
                    fillColor: '#0E21A0',
                    strokeColor: '#0E21A0',
                    size: 6,
                    shape: "circle"
                },
                chart: {
                    height: 350,
                    type: 'line',
                    color: '#0E21A0',
                    zoom: {
                        enabled: false
                    }
                },
                noData: {
                    text: "No Data",
                    align: "center",
                    verticalAlign: "middle",
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    colors: '#0E21A0',
                    curve: 'straight'
                },
                grid: {
                    row: {
                        colors: ['#f3f3f3', 'transparent'],
                        opacity: 0.5
                    },
                },
                xaxis: {
                    categories: localStorage.getItem('lang') == 'ar' ? arabicMonths : englishMonths,
                    title: {
                        text: 'All Categories'
                    }
                },
                yaxis: {
                    title: {
                        text: localStorage.getItem('lang') == 'ar' ? 'المتوسط (أيام)' : 'Average (Days)'
                    },
                },
            },
            averageCompletionStructuredataSeries: [{
                name: "Average completion in month",
                data: [],
                headerLabel: "Average Duration for Transfer Completion"
            }],
            structureChartOptions: {
                title: {
                    text: "",
                    floating: 0,
                    offsetY: 20,
                    align: "center",
                    style: {
                        color: "#444"
                    }
                },
                markers: {
                    seriesIndex: 0,
                    colors: '#0E21A0',
                    fillColor: '#0E21A0',
                    strokeColor: '#0E21A0',
                    size: 6,
                    shape: "circle"
                },
                chart: {
                    height: 350,
                    type: 'line',
                    color: '#0E21A0',
                    zoom: {
                        enabled: false
                    }
                },
                noData: {
                    text: "No Data",
                    align: "center",
                    verticalAlign: "middle",
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    colors: '#0E21A0',
                    curve: 'straight'
                },
                grid: {
                    row: {
                        colors: ['#f3f3f3', 'transparent'],
                        opacity: 0.5
                    },
                },
                xaxis: {
                    categories: localStorage.getItem('lang') == 'ar' ? arabicMonths : englishMonths,
                    title: {
                        text: 'All Categories'
                    }
                },
                yaxis: {
                    title: {
                        text: localStorage.getItem('lang') == 'ar' ? 'المتوسط (أيام)' : 'Average (Days)'
                    },
                },
            },
        }
    },
    watch: {
        filter: {
            handler(newFilter) {
                this.getAverageCompletion(newFilter.getAllHierarchy, newFilter.categoriesList, newFilter.fromYear);
            },
            deep: true,
        },
        completionValues: {
            handler(newCompletionValues) {
                this.averageCompletion = newCompletionValues.reduce((acc, currentValue) => acc + currentValue, 0) / 12;
                this.chartOptions.title.text = localStorage.getItem('lang') == 'ar' ? `المتوسط ​​الكلي: ${this.averageCompletion} ايام` : `Total Average: ${this.averageCompletion} day(s)`;
            }
        },
        activeStructureName: {
            handler(newActiveStructureName) {
                this.structureChartOptions.title.text = newActiveStructureName;
            }
        }
    },
    methods: {
        handleStructureClick(item) 
        {
            try 
            {
                if (this.activeStructureName !== item.name) {
                    this.showStructureGraph = false;
                    this.activeStructureName = item.name;
                }
                this.listUsers = [];
                this.listUsersIds = [];
                this.showListUsers = true;

                axios.post(constants.baseApiUrl + `Dashboard/StructureUsers?fromStructureId=${item.id}`, { headers: constants.headers })
                    .then(res => {
                        if (res != undefined) {
                            res.data.forEach(element => {
                                var user = {
                                    id: element.id,
                                    name: localStorage.getItem('lang') == 'ar' ? element.nameAr : element.name,
                                    username: element.username,
                                    average: 0,
                                    structureAverage: item.average,
                                    structureAverageComparison: 0,
                                    averageComparison: 0
                                };
                                this.listUsers.push(user);
                                this.listUsersIds.push(user.id);
                            });
                        }
                        this.forListDto.from = this.listUsersIds;
                        this.forListDto.year = this.filter.fromYear;
                        this.forListDto.categories = this.filter.categoriesList;
                        this.forListDto.getAllHierarchy = this.filter.getAllHierarchy;
                    })
                    .catch(error => alert(error))
                    .finally(f => this.getAverageCompletionforListUsers(this.forListDto))
            }
            catch (error) {
                console.log(error);
            }
        },
        handleStructureGraph(item) {
            if (this.activeStructureName !== item.name) {
                this.activeStructureName = item.name;
                this.structureCompletionValues = [];
                this.showStructureGraph = false;
                this.showListUsers = false;
            }
            this.getAverageCompletionFromStructure(this.tempFilter.getAllHierarchy, item.id, [], this.tempFilter.fromYear.id);
        },
        updateFilter() {
            if(this.tempFilter.categoriesList.length == 0 || this.tempFilter.fromYear == "") {
                window.showAlert("res_Msgs_FillRequired","warning");
                return ;
            }
            this.filter.fromYear = this.tempFilter.fromYear.id;
            this.filter.getAllHierarchy = this.tempFilter.getAllHierarchy;
            this.tempFilter.categoriesList.forEach(category => this.filter.categoriesList.push(category.id));
        },
        clearFilter() {
            this.tempFilter.categoriesList = [{ id: 0, name: '' }];
            this.tempFilter.fromYear = { id: new Date().getFullYear(), name: new Date().getFullYear() };
            this.tempFilter.getAllHierarchy = false;
        },
        validateYear() {
            const yearPattern = /^\d{4}$/;
            const currentYear = new Date().getFullYear();
            if (!yearPattern.test(this.tempFilter.fromYear) || parseInt(this.tempFilter.fromYear) > currentYear) {
                this.tempFilter.error = true;
            } else {
                this.tempFilter.error = false;
            }
        },
        getAverageCompletion(getAllHierarchy, categoriesList, fromYear) {
            try {
                this.completionValues = [];
                axios.post(constants.baseApiUrl + `Dashboard/AverageTransferCompletion?getAllHierarchy=${getAllHierarchy}&year=${fromYear}`, categoriesList, { headers: constants.headers })
                    .then(res => {
                        if (res != undefined) {
                            Object.values(res.data).forEach(value => {
                                this.completionValues.push(value);
                            });
                        }
                    })
                    .catch(error => alert(error));
            }
            catch (error) {
                console.log(error);
            }
            finally {
                this.averageCompletiondataSeries[0].data = this.completionValues;
                if (this.filter.getAllHierarchy)
                    this.asyncStructuresTreeView();
            }
        },
        getAverageCompletionFromStructure(getAllHierarchy, fromStructure, categoriesList, fromYear) {
            try {
                this.structureCompletionValues = [];
                axios.post(constants.baseApiUrl + `Dashboard/AverageTransferCompletion?getAllHierarchy=${getAllHierarchy}&fromStructure=${fromStructure}&year=${fromYear}`, categoriesList, { headers: constants.headers })
                    .then(res => {
                        if (res != undefined) {
                            Object.values(res.data).forEach(value => {
                                this.structureCompletionValues.push(value);
                            });
                            this.showStructureGraph = true;
                        }
                    })
                    .catch(error => alert(error));
            }
            catch (error) {
                console.log(error);
            }
            finally {
                this.averageCompletionStructuredataSeries[0].data = this.structureCompletionValues;
            }
        },
        async getAverageCompletionforListStructures(forListDto) {
            try {
                axios.post(constants.baseApiUrl + `Dashboard/AverageTransferCompletionForListStructures`, forListDto, { headers: constants.headers })
                    .then(res => {
                        if (res != undefined) {
                            this.items.map(item => {
                                item.average = res.data[item.id];
                                item.averageComparison = res.data[item.id] - this.averageCompletion;
                            });
                        }
                    })
                    .catch(error => alert(error))
            }
            catch (error) 
            {
                console.log(error);
            }
        },
        async getAverageCompletionforListUsers(forListDto) {
            try {
                axios.post(constants.baseApiUrl + `Dashboard/AverageTransferCompletionForListUsers`, forListDto, { headers: constants.headers })
                    .then(res => {
                        if (res) {
                            this.listUsers.forEach((user, index) => {
                                user.average = res.data[user.id];
                                user.structureAverageComparison = res.data[user.id] - res.data[user.id];
                                user.averageComparison = res.data[user.id] - this.averageCompletion;
                            });
                        }
                    })
                    .catch(error => alert(error))
                    .finally(f => { })
            }
            catch (error) {
                console.log(error);
            }
        },
        async asyncStructuresTreeView() {
            this.items = [];
            this.listStructuresIds = [];
            axios.get(constants.baseApiUrl + 'Admin/GetAllStructuresForOrganizationManagement')
                .then((res) => {
                    if (res.data != null) {
                        res.data.forEach(element => {
                            var item = {
                                id: element.id,
                                name: localStorage.getItem('lang') == 'ar' ? element.nameAr : element.name,
                                average: 0,
                                averageComparison: 0
                            };
                            this.items.push(item);
                            this.listStructuresIds.push(item.id);
                        });
                    }
                }).catch(err => console.warn(err))
                .finally(f => {
                    this.forListDto.from = this.listStructuresIds;
                    this.forListDto.year = this.filter.fromYear;
                    this.forListDto.categories = this.filter.categoriesList;
                    this.forListDto.getAllHierarchy = this.filter.getAllHierarchy;
                    this.getAverageCompletionforListStructures(this.forListDto);
                })
        },
        backToDashboardsPage() {
            router.push({ name: 'dashboards' })
        },
    },
    async mounted() {
        this.getAllHierarchyLabel = window.translate("res_Label_getAllHierarchy");
    }
};
</script>
<style scoped>
.label{
    font-weight: 500;
    font-size: 12px;
}
</style>
